function e() {
  return (e = Object.assign || function (e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];

      for (var c in t) {
        Object.prototype.hasOwnProperty.call(t, c) && (e[c] = t[c]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var i = {
  currency: "",
  position: "after",
  spaced: !0,
  decimals: "minmax",
  minDecimal: 0,
  maxDecimal: 2,
  decimalDelimiter: ".",
  thousandsDelimiter: ""
};
export default function (t, c) {
  var a = e({}, i, t);

  function r(e) {
    if (e = Number(e), isNaN(e)) e = "NaN";else {
      var _i = Math.pow(10, a.maxDecimal);

      e = Math.floor(e * _i).toString();

      var _t = a.maxDecimal + 1 - e.length;

      if (_t > 0) {
        var _i2 = "0";

        do {
          _t % 2 != 0 && (e = _i2 + e), _t = Math.floor(_t / 2), 0 != _t && (_i2 += _i2);
        } while (0 != _t);
      }

      var _c = e.length - a.maxDecimal,
          _r = e.slice(0, _c).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + a.thousandsDelimiter);

      var n = e.slice(_c);
      ("fluid" === a.decimals || "minmax" === a.decimals && n.slice(a.minDecimal).match(/^0*$/)) && (n = n.slice(0, a.minDecimal) + n.slice(a.minDecimal).replace(/0*$/, "")), e = _r + ("" === n ? "" : a.decimalDelimiter) + n;
    }
    return ("before" === a.position ? a.currency : "") + ("before" === a.position && a.spaced && "" !== a.currency ? " " : "") + e + ("after" === a.position && a.spaced && "" !== a.currency ? " " : "") + ("after" === a.position ? a.currency : "");
  }

  return void 0 === c ? r : r(c);
}